var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"font-wight-medium footer",attrs:{"min-height":"50","app":"","inset":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('span',[_vm._v("2.1.0 © "+_vm._s(new Date().getFullYear())+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }